import { a as rem, i as _responsive, n as _getArrayProp } from "./helpers-bwfx1e-Y.js";
import { t as getTheme_v2 } from "./getTheme_v2-y09KqtEb.js";
import { y as Box } from "./useLayer-BAVfmbNN.js";
import { t as responsiveFont } from "./responsiveFont-hN1mZFjm.js";
import { c } from "react/compiler-runtime";
import { css, styled } from "styled-components";
import { jsx } from "react/jsx-runtime";
/**
* Get responsive text align styles.
* @internal
*/
function responsiveTextAlignStyle(props) {
	let { media } = getTheme_v2(props.theme);
	return _responsive(media, props.$align, (textAlign) => ({ textAlign }));
}
/**
* Get responsive CSS for the `text` font style.
* @internal
*/
function responsiveTextFont(props) {
	return responsiveFont("text", props);
}
var spanWithTextOverflow = "elmvdc0";
/** @internal */
function SpanWithTextOverflow(props) {
	let $ = c(2), t0;
	return $[0] === props.children ? t0 = $[1] : (t0 = /* @__PURE__ */ jsx("span", {
		className: spanWithTextOverflow,
		children: props.children
	}), $[0] = props.children, $[1] = t0), t0;
}
function textBaseStyle(props) {
	let { $accent, $muted } = props, { font } = getTheme_v2(props.theme);
	return css`color:var(--card-fg-color);${$accent && css`color:var(--card-accent-fg-color);`} ${$muted && css`color:var(--card-muted-fg-color);`} & code{font-family:${font.code.family};border-radius:1px;background-color:var(--card-code-bg-color);color:var(--card-code-fg-color);}& a{text-decoration:none;border-radius:1px;color:var(--card-link-color);outline:none;@media (hover:hover){&:hover{text-decoration:underline;}}&:focus{box-shadow:0 0 0 1px var(--card-bg-color),0 0 0 3px var(--card-focus-ring-color);}&:focus:not(:focus-visible){box-shadow:none;}}& strong{font-weight:${font.text.weights.bold};}& svg{display:inline;max-width:unset;}& [data-sanity-icon]{vertical-align:baseline;color:var(--card-icon-color);& path{vector-effect:non-scaling-stroke !important;}}`;
}
const StyledText = /* @__PURE__ */ styled.div.withConfig({
	displayName: "StyledText",
	componentId: "sc-01ese4-0"
})(responsiveTextFont, responsiveTextAlignStyle, textBaseStyle);
function TextComponent(props) {
	let $ = c(27), align, childrenProp, ref, restProps, t0, t1, t2, textOverflow, weight;
	$[0] === props ? (align = $[1], childrenProp = $[2], ref = $[3], restProps = $[4], t0 = $[5], t1 = $[6], t2 = $[7], textOverflow = $[8], weight = $[9]) : ({accent: t0, align, children: childrenProp, muted: t1, ref, size: t2, textOverflow, weight, ...restProps} = props, $[0] = props, $[1] = align, $[2] = childrenProp, $[3] = ref, $[4] = restProps, $[5] = t0, $[6] = t1, $[7] = t2, $[8] = textOverflow, $[9] = weight);
	let accent = t0 !== void 0 && t0, muted = t1 !== void 0 && t1, size = t2 === void 0 ? 2 : t2, children = childrenProp;
	if (textOverflow === "ellipsis") {
		let t3;
		$[10] === children ? t3 = $[11] : (t3 = /* @__PURE__ */ jsx(SpanWithTextOverflow, { children }), $[10] = children, $[11] = t3), children = t3;
	}
	let t3;
	$[12] === align ? t3 = $[13] : (t3 = _getArrayProp(align), $[12] = align, $[13] = t3);
	let t4;
	$[14] === size ? t4 = $[15] : (t4 = _getArrayProp(size), $[14] = size, $[15] = t4);
	let t5;
	$[16] === children ? t5 = $[17] : (t5 = /* @__PURE__ */ jsx("span", { children }), $[16] = children, $[17] = t5);
	let t6;
	return $[18] !== accent || $[19] !== muted || $[20] !== ref || $[21] !== restProps || $[22] !== t3 || $[23] !== t4 || $[24] !== t5 || $[25] !== weight ? (t6 = /* @__PURE__ */ jsx(StyledText, {
		"data-ui": "Text",
		...restProps,
		$accent: accent,
		$align: t3,
		$muted: muted,
		ref,
		$size: t4,
		$weight: weight,
		children: t5
	}), $[18] = accent, $[19] = muted, $[20] = ref, $[21] = restProps, $[22] = t3, $[23] = t4, $[24] = t5, $[25] = weight, $[26] = t6) : t6 = $[26], t6;
}
/**
* The `Text` component is an agile, themed typographic element.
*
* @public
*/
const Text = TextComponent, BASE_STYLE = {
	"&&:not([hidden])": { display: "grid" },
	"&[data-as=\"ul\"],&[data-as=\"ol\"]": { listStyle: "none" },
	gridTemplateColumns: "minmax(0, 1fr)",
	gridAutoRows: "min-content"
};
function stackBaseStyle() {
	return BASE_STYLE;
}
function responsiveStackSpaceStyle(props) {
	let { media, space } = getTheme_v2(props.theme);
	return _responsive(media, props.$space, (spaceIndex) => ({ gridGap: rem(space[spaceIndex]) }));
}
const StyledStack = /* @__PURE__ */ styled(Box).withConfig({
	displayName: "StyledStack",
	componentId: "sc-zdrpl6-0"
})(stackBaseStyle, responsiveStackSpaceStyle);
function StackComponent(props) {
	let $ = c(13), as, gap, ref, restProps;
	$[0] === props ? (as = $[1], gap = $[2], ref = $[3], restProps = $[4]) : ({as, gap, ref, ...restProps} = props, $[0] = props, $[1] = as, $[2] = gap, $[3] = ref, $[4] = restProps);
	let t0 = typeof as == "string" ? as : void 0, t1;
	$[5] === gap ? t1 = $[6] : (t1 = _getArrayProp(gap), $[5] = gap, $[6] = t1);
	let t2;
	return $[7] !== as || $[8] !== ref || $[9] !== restProps || $[10] !== t0 || $[11] !== t1 ? (t2 = /* @__PURE__ */ jsx(StyledStack, {
		"data-as": t0,
		"data-ui": "Stack",
		...restProps,
		$space: t1,
		forwardedAs: as,
		ref
	}), $[7] = as, $[8] = ref, $[9] = restProps, $[10] = t0, $[11] = t1, $[12] = t2) : t2 = $[12], t2;
}
/**
* The `Stack` component is used to place elements on top of each other.
*
* @public
*/
const Stack = StackComponent;
export { responsiveTextAlignStyle as a, responsiveTextFont as i, Text as n, SpanWithTextOverflow as r, Stack as t };

//# sourceMappingURL=stack-C2HKTF-l.js.map